import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { alert } from '@crehana/tailwindcss/colors';

import ModernModal, {
  SIZE_ICON_MODERN_MODAL,
  TYPE_CONFIRM_BUTTON,
  WrapperIcon,
} from '@/views/AdminDashboard/components/ModernModal';

import type { IModalDeleteConfirmProps } from './types';

const iconProps = {
  size: 20,
  className: 'tw-text-alert-500',
};

const ModalDeleteConfirm: React.FC<IModalDeleteConfirmProps> = ({
  isOpen,
  onClose,
  onConfirm,
  titleLabel,
  descriptionLabel,
  closeButtonLabel,
  confirmButtonLabel,
}) => {
  return (
    <ModernModal
      centeredButtons
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      typeConfirmButton={TYPE_CONFIRM_BUTTON.ALERT}
      labelCloseButton={closeButtonLabel}
      labelConfirmButton={confirmButtonLabel}
    >
      <div className="tw-px-2">
        <WrapperIcon
          customColor={alert}
          className="mx-auto mt-24"
          type={SIZE_ICON_MODERN_MODAL.M}
        >
          <Trash2 {...iconProps} />
        </WrapperIcon>
        <p className="tw-font-h5 dark:tw-text-neutral-light-100 tw-font-semibold text-center mt-16">
          {titleLabel}
        </p>
        <p className="tw-font-body4 dark:tw-text-neutral-light-100 text-center mt-12">
          {descriptionLabel}
        </p>
      </div>
    </ModernModal>
  );
};

export default ModalDeleteConfirm;
